import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  standalone: true,
  selector: 'loader-spinner',
  templateUrl: './loader-spinner.component.html',
  imports: [ProgressSpinnerModule],
})

export class LoaderSpinnerComponent {
  @Input() title = 'Loading...';
}
